import script from "./mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile.vue?vue&type=script&setup=true&lang=js"

import "./mobile.vue?vue&type=style&index=0&id=bde7d894&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bde7d894"]])

export default __exports__